module.exports = __webpack_public_path__ + "img/Steven Waterhouse.28d6d440.jpg";